import {
  allContent,
  brandStories,
  newsItems,
  productItems,
  type ContentItem,
  type ContentType,
} from "@/mocks/content";

export const typeLabels: Record<ContentType, string> = {
  brand: "品牌介绍",
  news: "最新动态",
  product: "产品资讯",
};

export const typePaths: Record<ContentType, string> = {
  brand: "/brand",
  news: "/news",
  product: "/products",
};

export const typeCollections: Record<ContentType, ContentItem[]> = {
  brand: brandStories,
  news: newsItems,
  product: productItems,
};

export function getItemById(id: string): ContentItem | undefined {
  return allContent.find((item) => item.id === id);
}

export function getItemsByType(type: ContentType): ContentItem[] {
  return typeCollections[type];
}

export function sortByDateDesc(items: ContentItem[]): ContentItem[] {
  return [...items].sort((a, b) => (a.date < b.date ? 1 : -1));
}

export function getLatestNews(count = 3): ContentItem[] {
  return sortByDateDesc(newsItems).slice(0, count);
}

export function getFeaturedProducts(count = 4): ContentItem[] {
  return sortByDateDesc(productItems).slice(0, count);
}

export function getRelated(item: ContentItem, count = 3): ContentItem[] {
  const pool = allContent.filter((c) => c.id !== item.id);
  const byTag = pool.filter((c) => c.tags.some((t) => item.tags.includes(t)));
  const byType = pool.filter((c) => c.type === item.type && !byTag.includes(c));
  return [...byTag, ...byType].slice(0, count);
}

export function searchContent(keyword: string, limit = 8): ContentItem[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return allContent
    .filter(
      (item) =>
        item.title.toLowerCase().includes(key) ||
        item.summary.toLowerCase().includes(key) ||
        item.tags.some((t) => t.toLowerCase().includes(key)),
    )
    .slice(0, limit);
}

export function filterItems(
  items: ContentItem[],
  category: string,
): ContentItem[] {
  if (!category || category === "全部") return items;
  return items.filter((item) => item.category === category);
}

export function sortItems(
  items: ContentItem[],
  order: "latest" | "oldest" | "title",
): ContentItem[] {
  const copy = [...items];
  if (order === "oldest") return copy.sort((a, b) => (a.date > b.date ? 1 : -1));
  if (order === "title")
    return copy.sort((a, b) => a.title.localeCompare(b.title, "zh-Hans-CN"));
  return copy.sort((a, b) => (a.date < b.date ? 1 : -1));
}

export function paginate<T>(items: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

export function formatDate(date: string): string {
  const [y, m, d] = date.split("-");
  return `${y} 年 ${Number(m)} 月 ${Number(d)} 日`;
}